import styled from '@mui/material/styles/styled';
import Box from '@mui/material/Box';

export const Root = styled(Box)(({ theme }) => ({
  display: 'flex', 
  width: '100%',
  justifyContent: 'center',
  overflowY: 'auto',
  ...theme.scrollbars.default
}));